import React from 'react';
import { useSelector } from 'react-redux';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';
import { FLOWS_ENUM } from '../../common/enums';
import {
  selectDocumentUploadErrors,
  selectUpdatedPermitData,
  selectUpdateLicenseError,
  selectUpdateLicenseInProgress,
} from '../../store/slices/update/updateSelectors';
import {
  selectConfigExpressUpdate,
  selectConfigExpressApplyRentalStructureRequired,
  selectConfigExpressRegistrationTypeVerbiage,
  selectConfigExpressLocalContactVerbiage,
  selectConfigExpressParcelVerbiage,
} from '../../store/slices/config/configSelectors';
import { updatePermitData } from '../../store/slices/update/updateSlice';
import { updateLicense } from '../../store/slices/update/updateThunks';
import { ConfirmationPage } from 'src/components/pages/ConfirmationPage';
import { RegistrationFlow } from 'src/types/configuration';
import { useAppDispatch } from 'src/store/store';
import { ApplicationData } from 'src/types/flow';
import {
  setCurrentStep,
  setStepCompletedStatus,
} from 'src/store/slices/flow/flowSlice';
import { selectCurrentStep } from 'src/store/slices/flow/flowSelectors';

const UpdateConfirmation = () => {
  const placeNavigate = usePlaceNavigate();
  const dispatch = useAppDispatch();
  const configUpdate = useSelector(selectConfigExpressUpdate);
  const parcelVerbiage = useSelector(selectConfigExpressParcelVerbiage);
  const localContactVerbiage = useSelector(
    selectConfigExpressLocalContactVerbiage
  );
  const permitTypeVerbiage = useSelector(
    selectConfigExpressRegistrationTypeVerbiage
  );

  const selectedRentalStructureRequiredStatus = useSelector(
    selectConfigExpressApplyRentalStructureRequired
  );

  const uploadDocumentsError = useSelector(selectDocumentUploadErrors);

  const selectedPermitApplicationData = useSelector(
    selectUpdatedPermitData
  ) as ApplicationData;

  const isPerformingUpdate = useSelector(selectUpdateLicenseInProgress);
  const updateLicenseError = useSelector(selectUpdateLicenseError);
  const selectedCurrentStep = useSelector(selectCurrentStep);

  const finalizeOnNext = (wasSuccessfull: boolean = false) => {
    // If successfull go to the success page, else error messages will be displayed
    if (wasSuccessfull) {
      dispatch(
        setStepCompletedStatus({ stepNum: selectedCurrentStep, status: true })
      );
      dispatch(setCurrentStep(selectedCurrentStep + 1));
      placeNavigate('/update-success');
    }
  };
  const onConfirmation = (data: ApplicationData) => {
    dispatch(updatePermitData(data));
    dispatch(updateLicense(finalizeOnNext));
  };

  return (
    <ConfirmationPage
      config={configUpdate as RegistrationFlow}
      data={selectedPermitApplicationData}
      documentUploadErrors={uploadDocumentsError}
      flow={FLOWS_ENUM.UPDATE_CERTIFICATE}
      flowError={updateLicenseError}
      loading={isPerformingUpdate}
      localContactVerbiage={localContactVerbiage}
      onConfirmation={onConfirmation}
      parcelVerbiage={parcelVerbiage}
      permitTypeVerbiage={permitTypeVerbiage}
      rentalStructureRequiredStatus={selectedRentalStructureRequiredStatus}
    />
  );
};

export default UpdateConfirmation;
